<script>
    import {setStorage, getStorage} from '@/util'
    import moment from 'moment/min/moment-with-locales'
    import {mapActions} from "vuex";
    import dayjs from 'dayjs'

    export default {
        name: 'fn',
        mounted(){
            this.addFCMToken();
        },
        data() {
            return {
                moreLoading: false,
                dialogStateVisible: false,
                dialogTermsVisible: false,
                dialogUrlVisible: false,
                listLoading: true,
                detailLoading: true,
                loading: false,
                delayCheck: 0,
                delayTime: false,
                showDelayText: false,
                delayText: 0,
                linkData: {
                    name: '',
                    url: ''
                }
            }
        },
        computed: {},
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            goHome() {
                const {href} = this.$router.resolve({name: 'Home'})
                window.open(href, '_self')
            },
            /**
             * 千分號逗點/小數點最多五位 (沒有補0)
             * @param {string|number} number 金額
             */
            formatNumber(number, dit = 6) {
                const pattern = /(\d+)(\d{3})/
                const tails = /\.?0*$/
                // let num = returnState(number)
                let num = parseFloat(number)
                    .toFixed(dit)
                    .replace(tails, '')
                    .split('.')

                while (pattern.test(num[0])) {
                    num[0] = num[0].replace(pattern, '$1,$2')
                }

                num = num.join('.')

                return num === 'NaN' ? '' : num
            },
            /**
             * 深複製
             * @param {any} state 要複製的資料
             */
            returnState(data) {
                JSON.parse(JSON.stringify(data))
            },
            /**
             * 按鈕延遲
             */
            throttle(times) {
                this.showDelayText = true
                this.delayText = times
                if (this.delayText > 0) {
                    setTimeout(() => {
                        this.delayText--
                        this.throttle(this.delayText)
                    }, 1000);
                } else {
                    this.showDelayText = false
                }
            },
            // 表單驗證前
            beforeValidate() {
            },
            // 驗證失敗後處理
            handleUnValid() {
            },
            // 驗證通過,資料送出前
            beforeFormSubmit() {
            },
            handleCatch() {
                this.loading = false
            },
            //寫入註冊成功資訊
            handleToken(tokens) {
                setStorage('assessToken', tokens.accessToken)
                setStorage('refreshToken', tokens.refreshToken)
                // this.getFCMToken()
            },
            //清除登入資訊
            handleClearToken() {
                setStorage('assessToken', '')
                setStorage('refreshToken', '')
            },
            //取得新token並且重新取回資料
            checkNewToken(fn) {
                const token = getStorage('refreshToken')
                this.FETCH({
                    key: 'LOGIN_STATE',
                    refreshToken: token
                }).then((res) => {
                    if (!+(res || {}).code) {
                        this.handleToken((res || {}).data)
                        fn()
                    } else {
                        this.$confirm('登入逾時', {
                            showCancelButton: false,
                            type: 'error'
                        })
                            .then(() => {
                                location.href = '/app/'
                            })
                    }
                })
            },
            openTerms() {
                this.dialogTermsVisible = true
            },
            openPrivacy() {
                this.dialogStateVisible = true
            },
            openUrl(url, name) {
                if (url) {
                    this.linkData.name = name
                    this.linkData.url = url
                    this.dialogUrlVisible = true
                }
            },
            getPostDate(date) {
                moment.locale('zh-tw')
                return moment(date, "YYYY/MM/DD h:mm:s").fromNow();
            },
            checkArticleRenewDate(updatedAt) {
                var result = false;
                var nowDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                var articleDate = moment(updatedAt).format('YYYY-MM-DD');
                if(nowDate >= articleDate ){
                    result = true;
                }
                return result;
            },
            log(string){
                alert(string);
                console.log(string);
            },
            addFCMToken() {
                try {
                    var assessToken = getStorage('assessToken');
                    var addFCMTokenDay = getStorage('addFCMTokenDay');
                    var today = dayjs().format('YYYYMMDD');

                    if (assessToken != '' && addFCMTokenDay != today) {
                        var token = '';
                        window.flutter_inappwebview.callHandler('getFCMtoken').then(function (fcmtoken) {
                            sessionStorage.setItem('fcmtoken', fcmtoken);
                        });

                        token = sessionStorage.getItem('fcmtoken');
                        if (token != null) {
                            this.FETCH({
                                key: 'SET_FCM_TOKEN',
                                FCMTokne: token
                            })
                            setStorage('addFCMTokenDay', today)
                        }
                    }
                } catch (e) {
                    this.token = e;
                }
            },
            uniqid(prefix = "", random = false) {
                const sec = Date.now() * 1000 + Math.random() * 1000;
                const id = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
                return `${prefix}${id}${random ? `.${Math.trunc(Math.random() * 100000000)}` : ""}`;

            }
        }
    }
</script>
